var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIce1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 527,
    height: 356,
    viewBox: "0 0 527 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.579 140.969L454.62 168.975L450.835 172.297L507.184 122.971L481.617 80.0782L395.117 48.3293L388.473 45.8482L385.613 44.7969L253.866 18.9773L151.176 74.6115L41.6737 94.6701L19.7228 171.414L68.0821 176.629L74.2216 177.301L45.8368 174.232L19.7228 171.414L63.5825 302.489L95.7099 305.979L141.21 310.857L141.714 310.941L180.654 315.104H180.402L181.874 315.272L194.321 316.618L204.329 317.669L263.454 324.061L279.391 325.785L297.431 327.72L322.83 330.453L326.236 330.832L379.053 336.509L400.584 317.669L439.734 182.011L405.924 299.167H421.736L438.977 284.07L463.325 262.75L507.184 122.971L486.579 141.011V140.969Z",
    fill: "#00E7F9",
    stroke: "#00E7F9",
    strokeWidth: 37.8464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7228 171.414L63.5825 302.489L45.8368 174.232L19.7228 171.414Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.01 212.118L338.937 205.852L326.237 330.829L379.054 336.506L404.411 212.917L397.01 212.118Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.177 185.623L75.8628 177.465L95.7111 305.975L94.2814 305.807L141.715 310.937L141.211 310.853L151.177 185.623Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.825 196.682V323.005L225.061 319.893L237.172 194.873L197.602 190.626L204.33 317.664L194.322 316.571L190.873 189.869L173.8 188.019L181.832 315.225L180.655 315.099L297.39 327.714L305.968 202.317L253.825 196.682ZM263.412 324.056L275.565 201.391L279.308 325.78L263.37 324.056H263.412Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.62 168.974L450.835 172.296L454.62 168.974Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.978 284.071L463.326 262.751L507.186 122.972L486.58 141.012L438.978 284.071Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.181 199.125L404.411 212.918L379.054 336.507L400.584 317.668L439.734 182.01L420.181 199.125Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.176 185.586L173.8 188.067L190.873 189.875L225.06 153.963L197.601 190.632L237.171 194.879L253.824 196.687L306.01 202.322L336.833 205.644L338.936 205.854L397.009 212.12L404.41 212.919L420.18 199.126L439.734 182.011L409.288 166.284L391.711 171.414L367.699 160.228L395.117 166.284L409.246 160.228L450.835 172.297L507.184 122.971L481.617 80.0782L395.117 48.3293L374.764 64.0145L388.473 45.8482L385.613 44.7969L253.866 18.9773L151.176 74.6115L41.6316 94.6701L19.7228 171.414L68.0821 176.629L74.2216 177.301L75.8616 177.47L151.176 185.586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.937 205.852L397.01 212.118L338.937 205.852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.411 212.916L420.18 199.124L404.411 212.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.834 205.643L306.01 202.321L297.432 327.719L322.831 330.452L326.237 330.831L338.937 205.854L336.834 205.643Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.237 330.831L322.831 330.453L326.237 330.831Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.834 205.643L306.011 202.321L336.834 205.643L338.937 205.854L336.834 205.643Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.937 205.856L336.835 205.646L338.937 205.856Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.833 315.277L173.801 188.071L151.177 185.632L141.211 310.861L141.716 310.945L180.655 315.109H180.403L181.833 315.277Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.211 310.856L141.714 310.94L141.211 310.856Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.402 315.103H180.654L181.831 315.271L180.402 315.103Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.799 188.064L151.176 185.583V185.625L173.799 188.064Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.862 177.467L74.2219 177.299L45.8372 174.229L68.0824 176.626L45.8372 174.229L63.5829 302.486L95.7103 305.977L75.862 177.467Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8372 174.229L68.0824 176.626L45.8372 174.229Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8618 177.469L74.2218 177.301L75.8618 177.469Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.062 319.897L253.825 323.008V196.686L237.172 194.877L225.062 319.897Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.454 324.064L279.391 325.788L275.607 201.399L263.454 324.064Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.322 316.575L204.331 317.669L197.602 190.631L190.874 189.916L194.322 316.575Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.062 153.96L190.874 189.872L197.602 190.629L225.062 153.96Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.117 48.3302L388.473 45.8491L395.117 48.3302Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.118 48.3302L388.474 45.8491L374.765 64.0154L395.118 48.3302Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.579 140.966L454.62 168.972L486.579 141.008V140.966Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.621 168.972L450.836 172.294L421.736 299.163L438.977 284.067L486.58 141.008L454.621 168.972Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.734 182.015L450.835 172.301L439.734 182.015Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.835 172.301L439.733 182.015L405.924 299.171H421.735L450.835 172.301Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.118 166.284L367.7 160.229L391.711 171.415L409.289 166.284L439.734 182.012L450.836 172.298L409.247 160.229L395.118 166.284Z",
    fill: "#9BD6EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 525.308,
    height: 355.378,
    fill: "white",
    transform: "translate(0.799805 0.0546875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIce1);
export default __webpack_public_path__ + "static/media/ice-1.svg";
export { ForwardRef as ReactComponent };